import React, { ReactElement, useContext, useEffect } from 'react'
import axios from 'axios'
import MyArtWork from './MyArtWork'
import { Context } from '@/components/Context'
import serverConfig from '@/server-config'
import CheckBox from '@/components/boxes/CheckBox'
import { Art } from '@/database/art'
import { ArtState } from '@/database/types'
import { UpdateType } from '@/types/websocket'

axios.defaults.baseURL = serverConfig.baseURL

const isCreated = (currentAccount: string, art: Art): boolean => {
    return art.user.walletAddress === currentAccount
}

const isOwned = (currentAccount: string, art: Art): boolean => {
    return art.currentOwner === currentAccount
}

const isHidden = (art: Art): boolean => {
    return art.state === ArtState.HIDDEN
}

const PortfolioOverview = (): ReactElement => {
    const { filters, toggleFilter, portfolioData, currentAccount, setActiveUpdates } = useContext(Context)
    const { created, owned, hidden } = filters

    useEffect(() => {
        setActiveUpdates([UpdateType.PORTFOLIO])
    }, [])

    return (
        <div>
            <h1>Your Art</h1>
            <p>
                <CheckBox
                    btnName="Created"
                    classStyles=""
                    checked={created}
                    handleClick={() => toggleFilter('created')}
                />
                <CheckBox btnName="Owned" classStyles="" checked={owned} handleClick={() => toggleFilter('owned')} />
                <CheckBox btnName="Hidden" classStyles="" checked={hidden} handleClick={() => toggleFilter('hidden')} />
            </p>
            <ul>
                {portfolioData?.map((artData) => {
                    const isCreatedArt =
                        created && isCreated(currentAccount ?? '', artData.art) && !isHidden(artData.art)
                    const isOwnedArt = owned && isOwned(currentAccount ?? '', artData.art) && !isHidden(artData.art)
                    const isHiddenArt = hidden && isHidden(artData.art)
                    const isDefault = !created && !owned && !hidden && !isHidden(artData.art)
                    return (
                        (isCreatedArt || isOwnedArt || isHiddenArt || isDefault) && (
                            <MyArtWork
                                isOwned={isOwned(currentAccount ?? '', artData.art)}
                                key={artData.art.id}
                                artData={artData}
                            />
                        )
                    )
                })}
            </ul>
        </div>
    )
}

export default PortfolioOverview
